import { IconProps } from "@/types/common";
import React from "react";

const LibraryIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.66634 9.33398H9.33301V8.00065H6.66634V9.33398ZM6.66634 7.33398H11.9997V6.00065H6.66634V7.33398ZM6.66634 5.33398H11.9997V4.00065H6.66634V5.33398ZM5.33301 12.0007C4.96634 12.0007 4.65256 11.8702 4.39167 11.6093C4.13079 11.3484 4.00012 11.0344 3.99967 10.6673V2.66732C3.99967 2.30065 4.13034 1.98687 4.39167 1.72598C4.65301 1.4651 4.96679 1.33443 5.33301 1.33398H13.333C13.6997 1.33398 14.0137 1.46465 14.275 1.72598C14.5363 1.98732 14.6668 2.3011 14.6663 2.66732V10.6673C14.6663 11.034 14.5359 11.348 14.275 11.6093C14.0141 11.8707 13.7001 12.0011 13.333 12.0007H5.33301ZM5.33301 10.6673H13.333V2.66732H5.33301V10.6673ZM2.66634 14.6673C2.29967 14.6673 1.9859 14.5369 1.72501 14.276C1.46412 14.0151 1.33345 13.7011 1.33301 13.334V4.00065H2.66634V13.334H11.9997V14.6673H2.66634Z" />
    </svg>
  );
};

export default LibraryIcon;
